const s = (t) => !!(t && /^\d{6}$/.test(t)), a = (t) => !!(t && /^\d{4}$/.test(t)), n = (t, e, r) => `#${(t << 16 | e << 8 | r).toString(16).padStart(6, "0")}`;
export {
  s as isBrokerNumberValid,
  a as isIssuerNumberValid,
  n as rgbToHex
};
